import baseApi from '@store/api/baseApi';

import { toastError } from '@/components/Toast';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';

export const designDetailsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getMachingCount: builder.query({
			query: (params) => `/material/pair-material-count${params}`
		}),
		getPrintList: builder.query({
			query: () => ({
				url: 'garment-treatment/print-category-list'
			}),
			providesTags: ['GET_PRINT_LIST']
		}),
		createNewPrint: builder.mutation({
			query: ({ params }) => ({
				url: '/garment-treatment/create-print-category',
				method: 'POST',
				params
			}),
			invalidatesTags: ['GET_PRINT_LIST']
		}),
		getWashList: builder.query({
			query: () => ({
				url: '/garment-treatment/wash-category-list'
			}),
			providesTags: ['GET_WASH_LIST']
		}),
		createNewWash: builder.mutation({
			query: ({ body, params }) => ({
				url: '/garment-treatment/create-wash-category',
				method: 'POST',
				body,
				params
			}),
			invalidatesTags: ['GET_WASH_LIST']
		}),
		getEmbroideryList: builder.query({
			query: () => ({
				url: '/garment-treatment/embroidery-category-list'
			}),
			providesTags: ['GET_EMBROIDERY_LIST']
		}),
		createNewEmbroidery: builder.mutation({
			query: ({ body, params }) => ({
				url: '/garment-treatment/create-embroidery-category',
				method: 'POST',
				body,
				params
			}),
			invalidatesTags: ['GET_EMBROIDERY_LIST']
		}),
		updateTechpackChecklist: builder.mutation({
			query: ({ body, params, productId }) => ({
				url: `/product/${productId}/update-checklist`,
				method: 'PUT',
				body,
				params
			}),
			invalidatesTags: ['GET_TECHPACK_CHECKLIST', 'TECHPACK_CHECK_LIST_INFO']
		}),
		getIssueList: builder.query({
			query: ({ params, productId }) => ({
				url: `/issue/pending/${productId}`,
				params
			}),
			providesTags: ['GET_ISSUE_LIST'],
			async onQueryStarted(_args, { queryFulfilled }) {
				try {
					await queryFulfilled;
				} catch (error) {
					toastError(error?.data?.message || 'Something went wrong!');
				}
			}
		}),
		createIssue: builder.mutation({
			query: ({ body, params }) => ({
				url: `/issue/create`,
				method: 'POST',
				body,
				params
			}),
			invalidatesTags: ['GET_ISSUE_LIST']
		}),
		updateIssue: builder.mutation({
			query: ({ issueId, body }) => ({
				url: `/issue/${issueId}`,
				method: 'PUT',
				body
			}),
			invalidatesTags: ['GET_ISSUE_LIST']
		}),
		addIssueDocuments: builder.mutation({
			query: ({ issueId, body }) => ({
				url: `issue/${issueId}/documents`,
				method: 'POST',
				body
			}),
			invalidatesTags: ['GET_ISSUE_LIST']
		}),
		removeIssueDocument: builder.mutation({
			query: ({ issueId, params }) => ({
				url: `issue/issue/${issueId}`,
				method: 'DELETE',
				params
			}),
			invalidatesTags: ['GET_ISSUE_LIST']
		}),
		getProductFutureSample: builder.query({
			query: ({ productId }) => ({
				url: `/product-sample-inventory/${productId}/future-samples`,
				method: 'GET'
			}),
			keepUnusedDataFor: 0,
			invalidatesTags: ['FUTURE_SAMPLE']
		}),
		getDownloadCheckList: builder.query({
			query: ({ id }) => ({
				url: `/product/techpack/${id}/download-info `
			}),
			keepUnusedDataFor: 0,
			async onQueryStarted(_args, { queryFulfilled, dispatch }) {
				dispatch(openLoader());
				try {
					await queryFulfilled;
				} catch (error) {
					toastError(error?.data?.message || 'Something went wrong!');
				} finally {
					dispatch(closeLoader());
				}
			}
		})
	})
});

export const {
	useGetMachingCountQuery,
	useCreateNewPrintMutation,
	useGetPrintListQuery,
	useGetWashListQuery,
	useCreateNewWashMutation,
	useGetEmbroideryListQuery,
	useCreateNewEmbroideryMutation,
	useUpdateTechpackChecklistMutation,
	useGetIssueListQuery,
	useCreateIssueMutation,
	useUpdateIssueMutation,
	useRemoveIssueDocumentMutation,
	useAddIssueDocumentsMutation,
	useGetProductFutureSampleQuery,
	useGetDownloadCheckListQuery
} = designDetailsApi;
